import { logger as _s } from '@sentry/angular';

// Plain object wrapper so tests can spy on these methods.
// Sentry's logger is an ES module namespace whose properties are non-configurable
// getters — jasmine spyOn cannot patch them.
export const logger = {
  trace: _s.trace,
  debug: _s.debug,
  info: _s.info,
  warn: _s.warn,
  error: _s.error,
  fatal: _s.fatal,
};

export function isSurveyActionLog(level: string, attributes: Record<string, unknown> | undefined): boolean {
  return level === 'info' && attributes?.['category'] === 'survey' && typeof attributes['action'] === 'string';
}
